import PPIList from './ppi-list/ppi-list-container';
import PPIDetail  from './ppi-detail/ppi-detail-container';

export {
  PPIList,
  PPIDetail,
}



// WEBPACK FOOTER //
// ./src/component/ppi/index.js